/*
 * Copyright Mimic Networks, Inc. 2025.
 */

// This function will return whatever the MIMIC_MGMT_PLANE_ENVIRONMENT env var is, or 'local' if it is not set.
export function mimicEnv() {
  if (window.mimicConfig?.MIMIC_MGMT_PLANE_ENVIRONMENT) {
    return String(window.mimicConfig.MIMIC_MGMT_PLANE_ENVIRONMENT);
  }
  return 'local';
}

// Plugins (extensibility) are hidden in customer-facing envs until the feature is GA.
const PLUGINS_HIDDEN_ENVS = new Set(['uat', 'prod']);

export function arePluginsEnabled() {
  return !PLUGINS_HIDDEN_ENVS.has(mimicEnv());
}
